import { Message } from 'element-ui'
import $urls from '../../api/url'
import { i18n, locales } from '@/i18n'
import { updateElementTheme } from '@/functions/update-element-theme'
import shuyiLogoLight from '../../assets/img/logo-shuyi-light-mode.svg'
import shuyiLogoDark from '../../assets/img/logo-shuyi-dark-mode.svg'
import aiLogoLight from '../../assets/img/logo-ai-light-mode.svg'
import aiLogoDark from '../../assets/img/logo-ai-dark-mode.svg'
import aiDubbingLight from '../../assets/img/logo-aiDubbing-light-mode.svg'
import aiDubbingDark from '../../assets/img/logo-aiDubbing-dark-mode.svg'
import aiTongChuanLight from '../../assets/img/logo-aiTongChuan-light-mode.svg'
import aiTongChuanDark from '../../assets/img/logo-aiTongChuan-dark-mode.svg'

const state = {
  isPopFrame: false, // 是否嵌套
  language: 'zhcn', // 当前语种（来自其他系统）
  allResources: {
    default: { 'logo-light': shuyiLogoLight, 'logo-dark': shuyiLogoDark }, // 数译
    'AI Lab': { 'logo-light': aiLogoLight, 'logo-dark': aiLogoDark }, // Dtranx AI
    AIDubbing: { 'logo-light': aiDubbingLight, 'logo-dark': aiDubbingDark }, // AI Dubbing
    AITongChuan: { 'logo-light': aiTongChuanLight, 'logo-dark': aiTongChuanDark } // AI TongChuan
  },
  loginSource: {
    default: { 'logo-light': shuyiLogoLight, 'logo-dark': shuyiLogoDark }, // 数译
    url: $urls.dtranxUrl,
    buryingPointurl: 'SYHOME'
  }
}

const mutations = {
  showMsg (state, msg) {
    Message({
      message: msg.msg,
      type: msg.type,
      customClass: 'zZindex',
      duration: msg.duration || 3000
    })
  },
  setLoginSource (state, msg) {
    msg.url = msg.url || $urls.dtranxUrl
    msg.buryingPoint = msg.buryingPoint || 'SYHOME'
    localStorage.setItem('postMessage', JSON.stringify(msg))
    // 根据项目，确定相关资源
    const loginSource = state.allResources[msg.systemCode] || state.allResources.default
    localStorage.setItem('loginSource', JSON.stringify(loginSource))
    state.loginSource = {
      ...loginSource,
      ...msg
    }
    document.documentElement.setAttribute('data-theme', msg.setTheme || 'light')
    if (msg.languages) {
      i18n.locale = locales[msg.languages] || 'zh'
      state.language = locales[msg.languages] ? msg.languages : 'zhcn'
    }
    if (msg.themeColor) { // 更改主题色
      document.documentElement.style.setProperty('--primary-color', msg.themeColor)
      const primaryColor = msg.themeColor
      updateElementTheme({ primaryColor }).then()
    }
  },
  setIsPopFrame (state, msg) {
    state.isPopFrame = msg
  }
}

const actions = {
  getLoginSource (context, payload) {
    const isPopFrame = window.top !== window
    context.commit('setIsPopFrame', isPopFrame)
    /**
     * 应用系统postMessage对象结构说明
     * @typedef  {Object} PostMessage
     * @property  {String} url - 地址
     * @property  {String} systemCode - code值
     * @property  {String} buryingPoint - 埋点
     * @property  {String} themeColor - 主题色（具体颜色值）
     * @property  {String} setTheme - 主题（dark\light）
     * @property  {String} languages - 语种
     */
    /** @type {PostMessage} */
    let postMessage = {}
    if (isPopFrame) { // 嵌套
      window.addEventListener('message', e => {
        const hostStr = window.location.hostname
        const originStr = new URL(e.origin).hostname
        const originStr1 = originStr.split('.').slice(0, 2).join('.')
        const originStr2 = originStr.split('.').slice(-2).join('.')
        const allowDomainName = ['lan-bridge.cn', 'dtranx.com'].includes(originStr2) // 当为域名时
        if (e.origin !== location.origin) { // 钉钉扫码登录有嵌套自己，需排除
          console.log('统一登录收到来自父页面的消息：', e.data)
          if (+originStr1 === 192.168 || originStr1 === 'localhost' || originStr === hostStr || allowDomainName) {
            const { eventType, data } = e.data || {}
            if (eventType === 'sendMessage') {
              postMessage = data || {}
              context.commit('setLoginSource', postMessage)
            }
          } else {
            console.error('嵌套来源不合规！')
          }
        }
      })
    } else {
      try {
        const data = window.name
        console.log('window.name的值：', data)
        if (data) {
          const obj = JSON.parse(data)
          postMessage = {
            systemCode: obj?.source || '',
            buryingPoint: obj?.source || '',
            ...obj
          }
        }
      } catch (err) {
        console.error('window.name的值有误')
      }
      context.commit('setLoginSource', postMessage)
    }
  }
}

export default {
  state,
  mutations,
  actions
}
